module.exports = __webpack_public_path__ + "static/media/iazzu-thumbs-discover.2d290a31.jpg";